import { useState } from "react";
import Pill from "../Pill/Pill";
import { iprUpperIndexes, iprLowerIndexes, getIprUpperIndex, getIprLowerIndex } from "./utils";
import { UnorderedListOutlined } from "@ant-design/icons";
import "./ipr.scss";
import { primaryColor } from "colors-config";

const Row = ({ row }) => {
  const { beforeStage, teethNo, iprValue } = row;
  return (
    <div className="row">
      <div className="cell">
        <Pill option="circular" text={beforeStage} />
      </div>
      <div className="cell">
        <Pill option="rectangular" text={teethNo} color={primaryColor} textColor={"#fff"}/>
      </div>
      <div className="cell">
        <Pill option="rectangular" text={iprValue} />
      </div>
    </div>
  );
};

const Divider = () => (
  <div style={{ width: "100%", height: "2px", background: "#393A3E" }}></div>
);

const Table = ({
  iprData,
  upperModelIndex,
  lowerModelIndex,
  showIprTable,
  setShowIprTable,
  chartValue
}) => {
  const [] = useState([]);
  const upperValues = [];
  const lowerValues = [];

  iprData?.forEach((el) => {
    if (el.jawType === "upper" && el.aligner_count === upperModelIndex) {
      upperValues.push(el);
    }
    if (el.jawType === "lower" && el.aligner_count === lowerModelIndex) {
      lowerValues.push(el);
    }
  });

  const selectedAlignerDataUpper =
    upperValues.length > 1
      ? upperValues.filter((el) => el.aligner_count === upperModelIndex)
      : [upperValues[0]];

  const selectedAlignerDataLower =
    lowerValues.length > 1
      ? lowerValues.filter((el) => el.aligner_count === lowerModelIndex)
      : [lowerValues[0]];

  const tableData = [];
  // console.log("selectedAlignerDataUpper", selectedAlignerDataUpper)

  const beforeStageUpper = upperValues.length > 1 ? upperModelIndex : 1;
  selectedAlignerDataUpper[0]?.alignerValues.forEach((el, index) => {
    if (el?.value) {
      tableData.push({
        beforeStage: selectedAlignerDataUpper[0].aligner_count,
        teethNo: getIprUpperIndex(index, chartValue),
        iprValue: el.value,
      });
    }
  });

  const beforeStageLower = lowerValues.length > 1 ? lowerModelIndex : 1;
  selectedAlignerDataLower[0]?.alignerValues.forEach((el, index) => {
    if (el?.value) {
      tableData.push({
        beforeStage: selectedAlignerDataLower[0].aligner_count,
        teethNo: getIprLowerIndex(index, chartValue),
        iprValue: el.value,
      });
    }
  });

  if (tableData.length === 0) return <p className="empty-container">No IPR for this stage</p>;

  return (
    <>
      {/* <div
        onClick={() => setShowIprTable((prev) => !prev)}
        className="view-list"
        style={{ opacity: tableData.length ? "1" : "0" }}
      >
        <p>View IPR Details</p> <UnorderedListOutlined />
      </div> */}

      <div
        className={"ipr-tabless"}
      >
        <div className="row">
          <span className="table-col">Before Stage #</span>
          <span className="table-col">Teeth #</span>
          <span className="table-col">IPR Value</span>
        </div>

        <div className="ipr-table-container">
          {tableData.map((row, index) => (
            <div key={index}>
              <Row row={row} />
              {tableData.length - 1 !== index && <Divider />}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Table;
